module.exports = __webpack_public_path__ + "static/media/video_placeholder.aaae544e.svg";